export default __webpack_public_path__ + "static/animal-f4982ded52c1cd83a8b874394e4e88ec.jpg";